import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable  } from '@angular/core';
import { STORAGE_ENUM } from '../../../auth/enums/storage.enum';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';
import { SessionService } from '../../../auth/services/session/session.service';
import { environment } from '../../../../environments/environment.development';
import { Observable } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class AcademyService {

    private _http = inject(HttpClient);
    private _sessionService = inject(SessionService);
    private _localStorage = inject(LocalStorageService);

  private url = `${environment.apiUrl}/administrative/academy/?type_course=CU&is_active=true`;
  constructor() { }

  getCourses(): Observable<any> {
    const token = this._localStorage.get(STORAGE_ENUM.TOKEN);
    let params = new HttpParams();

     return this._http.get<any>(this.url, { headers: { Authorization: `Bearer ${token}` } });
  }

}
